import { useEffect } from "react";

const SITE = "https://mortgagesurvivalplaybook.com";
const DEFAULT_IMAGE = `${SITE}/assets/og-image.jpg`;

const setMeta = (selector, attr, name, content) => {
  if (content == null) return;
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

// Sets a unique title, description, canonical, robots + Open Graph/Twitter tags per page (SPA-friendly).
export const useSEO = (title, description, { noindex = false, image, type = "website" } = {}) => {
  useEffect(() => {
    const url = `${SITE}${window.location.pathname}`;
    const img = image || DEFAULT_IMAGE;
    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(url);
    // Open Graph
    if (title) setMeta('meta[property="og:title"]', "property", "og:title", title);
    if (description) setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    setMeta('meta[property="og:type"]', "property", "og:type", type);
    setMeta('meta[property="og:image"]', "property", "og:image", img);
    // Twitter
    setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    if (title) setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    if (description) setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", img);
    return () => setMeta('meta[name="robots"]', "name", "robots", "index, follow");
  }, [title, description, noindex, image, type]);
};
